import { CreateScheduledNotificationDto, ScheduledNotificationDto, UpdateScheduledNotificationDto } from '../../sdk'

export enum ScheduledNotificationsActionTypes {
  GET_NOTIFICATIONS_REQUEST = '@@scheduledNotifications/GET_NOTIFICATIONS_REQUEST',
  GET_NOTIFICATIONS_SUCCESS = '@@scheduledNotifications/GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILURE = '@@scheduledNotifications/GET_NOTIFICATIONS_FAILURE',

  CREATE_NOTIFICATION_REQUEST = '@@scheduledNotifications/CREATE_NOTIFICATION_REQUEST',
  CREATE_NOTIFICATION_SUCCESS = '@@scheduledNotifications/CREATE_NOTIFICATION_SUCCESS',
  CREATE_NOTIFICATION_FAILURE = '@@scheduledNotifications/CREATE_NOTIFICATION_FAILURE',

  UPDATE_NOTIFICATION_REQUEST = '@@scheduledNotifications/UPDATE_NOTIFICATION_REQUEST',
  UPDATE_NOTIFICATION_SUCCESS = '@@scheduledNotifications/UPDATE_NOTIFICATION_SUCCESS',
  UPDATE_NOTIFICATION_FAILURE = '@@scheduledNotifications/UPDATE_NOTIFICATION_FAILURE',

  DELETE_NOTIFICATION_REQUEST = '@@scheduledNotifications/DELETE_NOTIFICATION_REQUEST',
  DELETE_NOTIFICATION_SUCCESS = '@@scheduledNotifications/DELETE_NOTIFICATION_SUCCESS',
  DELETE_NOTIFICATION_FAILURE = '@@scheduledNotifications/DELETE_NOTIFICATION_FAILURE',
}

export interface GetScheduledNotificationsRequest {
  type: typeof ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_REQUEST
}

interface GetScheduledNotificationsSuccess {
  type: typeof ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_SUCCESS
  response: ScheduledNotificationDto[]
}

interface GetScheduledNotificationsFailure {
  type: typeof ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_FAILURE
  errorMsg: string
}

export interface CreateScheduledNotificationRequest {
  type: typeof ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_REQUEST
  data: CreateScheduledNotificationDto
}

interface CreateScheduledNotificationSuccess {
  type: typeof ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_SUCCESS
}

interface CreateScheduledNotificationFailure {
  type: typeof ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_FAILURE
  errorMsg: string
}

export interface UpdateScheduledNotificationRequest {
  type: typeof ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_REQUEST
  id: string
  data: UpdateScheduledNotificationDto
}

interface UpdateScheduledNotificationSuccess {
  type: typeof ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_SUCCESS
}

interface UpdateScheduledNotificationFailure {
  type: typeof ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_FAILURE
  errorMsg: string
}

export interface DeleteScheduledNotificationRequest {
  type: typeof ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_REQUEST
  id: string
}

interface DeleteScheduledNotificationSuccess {
  type: typeof ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_SUCCESS
}

interface DeleteScheduledNotificationFailure {
  type: typeof ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_FAILURE
  errorMsg: string
}

export interface ScheduledNotificationsState {
  all: ScheduledNotificationDto[]
  errorMsg: string
  loading: boolean
}

export type ScheduledNotificationsActionType =
  GetScheduledNotificationsRequest |
  GetScheduledNotificationsSuccess |
  GetScheduledNotificationsFailure |
  CreateScheduledNotificationRequest |
  CreateScheduledNotificationSuccess |
  CreateScheduledNotificationFailure |
  UpdateScheduledNotificationRequest |
  UpdateScheduledNotificationSuccess |
  UpdateScheduledNotificationFailure |
  DeleteScheduledNotificationRequest |
  DeleteScheduledNotificationSuccess |
  DeleteScheduledNotificationFailure
